import { isValidEmail } from "../types/BaseTypes.ts";
import {
  TEXT_EMAIL_LENGTH,
  TEXT_EMAIL_VALID,
  TEXT_OTP_RESET_LENGTH,
  TEXT_OTP_VERIFY_LENGTH,
  TEXT_PASSWORD_LONG,
  TEXT_PASSWORD_SHORT,
} from "./text.ts";

export const EMAIL_VALIDATOR = {
  length: (v: string) => v.length > 3 || TEXT_EMAIL_LENGTH,
  format: (v: string) => isValidEmail(v) || TEXT_EMAIL_VALID,
};

export const PASSWORD_VALIDATOR = {
  short: (v: string) => v.length >= 8 || TEXT_PASSWORD_SHORT,
  long: (v: string) => v.length <= 64 || TEXT_PASSWORD_LONG,
};

export const OTP_VERIFY_VALIDATOR = {
  length: (v: string) => v.length == 6 || TEXT_OTP_VERIFY_LENGTH,
};

export const OTP_RESET_VALIDATOR = {
  length: (v: string) => v.length == 16 || TEXT_OTP_RESET_LENGTH,
};
